export function createPovButton({ onEnter, onExit, getMode }) {
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'pov-btn';
  btn.textContent = '站上 Trisolaris';
  document.body.appendChild(btn);

  function paint() {
    const mode = getMode();
    if (mode === 'pov') {
      btn.textContent = '返回旁观 · ESC';
      btn.title = '拖拽环视；镜头会缓慢跟随天空中的恒星';
      btn.classList.add('active');
    } else if (mode === 'transition') {
      btn.textContent = '镜头切换中…';
      btn.classList.add('active');
    } else {
      btn.textContent = '站上 Trisolaris';
      btn.title = '地表仰望三星（可反复进出）';
      btn.classList.remove('active');
    }
  }

  btn.addEventListener('click', (e) => {
    e.stopPropagation();
    const mode = getMode();
    if (mode === 'pov') onExit();
    else if (mode === 'orbit') onEnter();
    // ignore clicks mid-transition
    paint();
  });

  return {
    el: btn,
    refresh: paint,
  };
}
